import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { LanguageToggle } from './LanguageToggle';

export const AuthLandingLayout = () => {
  const { t } = useTranslation();

  return (
    <main>
      <Outlet />
    </main>
  );

  return (
    <div className="flex min-h-screen flex-col bg-neutral-50 lg:flex-row">
      {/* Colonne gauche : Formulaire */}
      <div className="flex h-screen w-full flex-col items-center justify-center bg-white px-6 py-12 lg:w-1/2 lg:py-0">
        <div className="mx-auto w-full max-w-lg">
          <div className="mb-4 flex justify-end">
            <LanguageToggle />
          </div>
          <main>
            <Outlet />
          </main>
        </div>
      </div>
      {/* Colonne droite : Témoignage + illustration */}
      <div className="bg-primary-600 relative hidden w-1/2 items-center justify-center overflow-hidden lg:flex">
        <div className="mx-auto max-w-lg px-8 text-white">
          <blockquote className="mb-8 text-2xl leading-snug font-medium">
            {t('landing.testimonial')}
          </blockquote>
          <div className="flex justify-center gap-4">
            {/* Placeholder for screenshots/illustration */}
            <div className="h-72 w-40 rounded-xl border border-white/20 bg-white/10 shadow-lg" />
            <div className="h-72 w-64 rounded-xl border border-white/20 bg-white/10 shadow-lg" />
          </div>
        </div>
        {/* Décor rond en fond */}
        <div className="bg-primary-700 absolute -right-32 -bottom-32 h-96 w-96 rounded-full opacity-30" />
      </div>
    </div>
  );
};
